<template>
  <transition name="fade">
    <div class="suggestion-modal" v-if="showSuggestionModal" :class="{ loading: isSubmitting }">
      <div class="suggestion-content">
        <a class="close-button" @click="closeSuggestionModal" :class="{ disabled: isSubmitting }">✕</a>
        <h3>{{ modalType === 'suggestion' ? 'Suggest a Question' : 'Send Feedback' }}</h3>
        <textarea
          v-model="suggestionText"
          :placeholder="modalType === 'suggestion' ? 'Type your question suggestion here...' : 'Share your feedback or suggestions...'"
          class="suggestion-input"
          :disabled="isSubmitting"
        ></textarea>
        <div class="modal-buttons">
          <button
            class="submit-button"
            @click="submitSuggestion"
            :disabled="!suggestionTextValue.trim() || isSubmitting"
          >
            <span class="loading-spinner" v-if="isSubmitting"></span>
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { useStore } from '../store';
import { mapState, mapActions } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, ['showSuggestionModal', 'isSubmitting', 'modalType']),
    suggestionText: {
      get() {
        return useStore().suggestionText;
      },
      set(value) {
        useStore().suggestionText = value;
      },
    },
    suggestionTextValue() {
      return useStore().suggestionText;
    }
  },
  methods: {
    ...mapActions(useStore, ['closeSuggestionModal', 'submitSuggestion']),
  },
};
</script>

<style scoped>
.suggestion-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 90%;
    background-color: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    animation: slideUp 0.3s ease-out;
    transition: background-color 0.3s ease;
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0);
    }
}

.suggestion-content {
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: relative;
}

.suggestion-input {
    width: 90%;
    height: 100px;
    padding: 10px;
    border: 2px solid var(--raspberry-pink);
    border-radius: 10px;
    resize: none;
    font-family: 'Baloo', sans-serif;
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
    line-height: 1.5;
}

.submit-button {
    background-color: var(--raspberry-pink);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
    align-self: flex-end;
}

.close-button {
    color: white;
    background-color: var(--raspberry-pink);
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
}

.suggestion-modal.loading {
    opacity: 0.7;
    pointer-events: none;
}

.suggestion-modal.loading .suggestion-input {
    background-color: #f5f5f5;
    cursor: not-allowed;
}

.suggestion-modal.loading .submit-button {
    opacity: 0.7;
    cursor: not-allowed;
}

body.dark-mode .suggestion-modal {
    background-color: var(--background-dark);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
}

body.dark-mode .suggestion-modal h3 {
    color: var(--text-dark);
}

body.dark-mode .suggestion-input {
    background-color: #2b2b2b;
    border-color: #444;
    color: var(--text-dark);
}

body.dark-mode .suggestion-input::placeholder {
    color: #888;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.loading-spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 1s ease-in-out infinite;
    margin-right: 8px;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>
